import { Slider } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHotelDataContext } from "../../../../../../hooks/HotelDataContextHook";
import { useAppSelector } from "../../../../../../hooks/reduxHooks";
import { useQueryParams } from "../../../../../../hooks/useQueryParams";
import useThrottle from "../../../../../../hooks/useThrottle";
import { selectCurrency } from "../../../../../../redux/slices/enviromentSlice/EnviromentSlice.selectors";
import {
  getHotelMinMaxPrices,
  getMinPrice,
} from "../../../../../../utils/getPriceUtils";
import { filterStateI } from "../../../../contexts/filterContext";
import styles from "./PriceSlider.module.scss";

const PriceSlider: React.FC<{
  setFilterState: Function;
  filterState: filterStateI;
}> = (props) => {
  // redux hooks
  const currency = useAppSelector(selectCurrency);

  const { setFilterState, filterState } = props;

  const { filteredHotelDataList: hotelDataList } = useHotelDataContext();
  const [value, setValue] = useState(filterState.priceRange);
  // const [prices, setPrices] = useState<string[]>([]);
  // const [maxPrice, setMaxPrice] = useState("");
  // const [minPrice, setMinPrice] = useState("");
  const [availablePriceRange, setAvailablePriceRange] =
    useState<[number, number]>();
  const firstLoading = useRef(true);
  const { t } = useTranslation();
  const throttle = useThrottle();
  const { priceRange, setQueryParams } = useQueryParams();

  useEffect(() => {
    const initialCall = () => {
      let currentMinPrice: string | undefined = undefined;
      let currentMaxPrice: string | undefined = undefined;
      const [maxMinPrice, maxMaxPrice] = hotelDataList.reduce((acum, hotel) => {
        const { maxPrice, minPrice } = getHotelMinMaxPrices(hotel);
        if (minPrice && (acum[0] === undefined || minPrice < acum[0])) {
          acum[0] = minPrice;
        }
        if (maxPrice && (acum[1] === undefined || maxPrice > acum[1])) {
          acum[1] = maxPrice;
        }
        return acum;
      }, [] as string[]);

      if (maxMinPrice && maxMaxPrice) {
        setAvailablePriceRange([+maxMinPrice, +maxMaxPrice]);
        if (!value) setValue([+maxMinPrice, +maxMaxPrice]);
      }
      // if (currentMinPrice && currentMaxPrice) {
      //   setMinPrice(currentMinPrice);
      //   setValue((currentValue) => {
      //     const newValue = [...currentValue];
      //     newValue[0] = +currentMinPrice!;
      //     return newValue;
      //   });
      // }
      // if (currentMaxPrice) {
      //   setMaxPrice(currentMaxPrice);
      //   setValue((currentValue) => {
      //     const newValue = [...currentValue];
      //     newValue[1] = +currentMaxPrice!;
      //     return newValue;
      //   });
      // }
      // setPrices(priceArray);
    };

    initialCall();
  }, [filterState.priceRange?.length, hotelDataList]);

  useEffect(() => {
    if (!value) return;
    // if (!value[0] || !value[1]) return;
    if (firstLoading.current) {
      firstLoading.current = false;
      return;
    }
    throttle({
      callback: () => {
        setFilterState((prevState: filterStateI) => ({
          ...prevState,
          priceRange: value,
        }));
      },
      throttleTime: 500,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstLoading.current, value]);

  const onlyOnePriceAvail =
    availablePriceRange && availablePriceRange[0] === availablePriceRange[1];

  console.log(
    availablePriceRange,
    availablePriceRange && availablePriceRange[0],
    availablePriceRange && availablePriceRange[1]
  );

  return (
    <div className={styles.mainContainer}>
      {onlyOnePriceAvail ? (
        t("filters.onlyOneAvailablePrice")
      ) : (
        <>
          {availablePriceRange ? (
            <>
              <div className={styles.priceRangeSelected}>
                {`${value![0]}${currency} - ${value![1]}${currency}`}
              </div>
              <Slider
                value={value}
                onChange={(_, newValue: number | number[]) => {
                  if (Array.isArray(newValue)) {
                    setValue(newValue);
                  }
                }}
                min={availablePriceRange[0]}
                max={availablePriceRange[1]}
                valueLabelDisplay="auto"
                aria-labelledby="range-slider"
              />
            </>
          ) : (
            t("filters.noAvailablePrices")
          )}
        </>
      )}
    </div>
  );
};

export default PriceSlider;
